import { tap, take, catchError } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable, Subject, timer, empty, EMPTY } from 'rxjs';
import { Servidor } from '../_classes/servidor';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { Util } from '../_classes/util';
import { SgrhCreditoHora } from '../_classes/sgrh-credito-hora';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { EnvService } from '../_servicos/env.service';

@Component({
  selector: 'app-sgrh-credito-hora',
  templateUrl: './sgrh-credito-hora.component.html',
  styleUrls: ['./sgrh-credito-hora.component.scss'],
})
export class SgrhCreditoHoraComponent implements OnInit {
  carregando = false;
  displayedColumns: string[] = [
    'dt',
    'dsEvento',
    'nrMinMarcado',
    'nrMinTrabalhado',
  ];

  //servidor$: Observable<Servidor>;
  //servidor: Servidor = new Servidor();
  totalHoras: number = 0;
  dsCreditoHora$: Observable<number>;

  erros$ = new Subject<boolean>();
  dataSource$: Observable<SgrhCreditoHora[]>;
  dataSource: MatTableDataSource<SgrhCreditoHora>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  itensAjuda = [
    {
      titulo: 'Data',
      texto: 'Data trabalhada na qual foi-se gerado o crédito',
    },
    {
      titulo: 'Evento',
      texto: 'Descrição do evento que gerou o crédito',
    },
    {
      titulo: 'Marcado',
      texto: 'Quantidade de minutos marcados para usufruir',
    },
    {
      titulo: 'Trabalhado',
      texto: 'Quantidade de minutos que foram trabalhados, gerando o crédito',
    },
  ];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {
    //this.dataSource = new MatTableDataSource([]);
    //this.atualizarPaginador();
  }

  ngOnInit() {
    this.atualizar();
  }
  /*
  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
  }*/

  executarAoCarregarDatasource(x: SgrhCreditoHora[]) {
    //console.log('credito hora', x);
    this.dataSource = new MatTableDataSource<SgrhCreditoHora>(x);
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
    this.carregando = false;
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    this.dataSource$ = this.service
      .listarSgrhCreditoHora(this.env.servidor.idServidor)
      .pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );

    this.service
      .getQuantidadeSgrhCreditoHora(this.env.servidor.idServidor)
      .pipe(take(1))
      .subscribe(
        (a) => {
          //console.log( 'retornei a quantidade de horas (getQuantidadeSgrhCreditoHora)'            );
          //console.log(a);
          this.totalHoras = a;
        },
        (e) => {
          this.handleError(e);
          return EMPTY;
        }
      );
  }
  /*
  atualizarOld() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    this.servidor =
      this.servService.getServidorAtualRedirecionando('sgrh-credito-dia');

    this.servidor$ = this.servService.getServidor().pipe(
      tap((x) => this.executarAoCarregarServidor(x)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return empty();
      })
    );

    if (this.servidor) {
      this.dataSource$ = this.service
        .listarSgrhCreditoHora(this.servidor.idServidor)
        .pipe(
          tap((a) => this.executarAoCarregarDatasource(a)),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return empty();
          })
        );

      this.service
        .getQuantidadeSgrhCreditoHora(this.servidor.idServidor)
        .pipe(take(1))
        .subscribe(
          (a) => {
            //console.log( 'retornei a quantidade de horas (getQuantidadeSgrhCreditoHora)'            );
            //console.log(a);
            this.totalHoras = a;
          },
          (e) => {
            this.handleError(e);
            return empty();
          }
        );
    }
  }*/

  vencido(d: SgrhCreditoHora): boolean {
    //    return Util.dataVencida(new Date(d), new Date());
    let retorno: boolean = false;
    if (d) {
      if (d?.dtValidade) {
        if (d?.nrMinMarcado) {
          if (d?.nrMinTrabalhado) {
            if (d?.nrMinTrabalhado > d?.nrMinMarcado) {
              retorno = Util.dataVencida(new Date(d.dtValidade), new Date());
            }
          }
        }
      }
    }
    return retorno;
  }

  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
